import Cookies from "js-cookie";

export function runExperiment(
  experimentName: string,
  holdoutPercentage: number
) {
  const cookieName = `punchup-experiment-${experimentName}`;
  const cookieValue = Cookies.get(cookieName);

  if (cookieValue) {
    return cookieValue === "true";
  }

  const randomValue = Math.random() * 100;
  const isHoldout = randomValue < holdoutPercentage;

  Cookies.set(cookieName, isHoldout.toString(), { expires: 365 });

  return isHoldout;
}
